/**
 * Surface areas are high-level product sections / entry points.
 *
 * Keep these stable (they become part of event payloads).
 */
export const MIXPANEL_SURFACE_AREA = {
  THREADS: 'threads',
  DOCUMENTS: 'documents',
  SETTINGS: 'settings',
  SERVICE_DRAWER: 'service_drawer',
  CORPORATIONS_TAB: 'corporations_tab',
  ENTITY_MANAGEMENT: 'entity_management',
  COMPLIANCE_CALENDAR: 'compliance_calendar',
  INDIRECT_TAX_APP: 'indirect_tax_app',
  ECM_PORTAL: 'ecm_portal',
  TP_APP: 'tp_app',
  TA_APP: 'ta_app',
  CLIENT_HOME: 'global_home',
  ALL_APP_HOMEPAGES: 'all_app_homepages',
  AGENT_APP: 'agent_app',
  AFFILIATE_APP: 'affiliate_app',
  SERVICES_TAB: 'services_tab',
  CLIENT_APP: 'client_app',
  WORKFLOW_AND_FORM_BUILDER: 'workflow_and_form_builder',
  COMMENDA_APP: 'commenda_app',
  FORMS: 'forms',
  DOCUMENTS_TAB: 'documents_tab',
  SALES_TAX_APP: 'sales_tax_app',
  ADMIN_APP_AGENTS: 'admin_app_agents',
  SERVICE_DELIVERY: 'ServiceDelivery',
  MAILROOM: 'mailroom',
  CALENDAR: 'calendar',
} as const;

export type MixpanelSurfaceArea =
  (typeof MIXPANEL_SURFACE_AREA)[keyof typeof MIXPANEL_SURFACE_AREA];
